module.exports = __webpack_public_path__ + "fonts/AdelleSAGE-Bold.887dcc6b.eot";